import Box from '@mui/material/Box'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Cards from '../components/Cards/Cards';
import Accordions from '../components/Accordions/Accordions'
import CompareSlider from '../components/Slider/CompareSlider'
import SmallCards from '../components/Cards/SmallCards'
import ContentCard from '../components/Cards/ContentCard'
import TextBtnSection from '../components/Section/TextBtnSection'
import BigCard from '../components/Cards/BigCard'
import { useTranslation } from '../hook/Translation'

export default function HybridLaserGlass() {
    const { t } = useTranslation();

    const data = [
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 17.png`,
            header: t('face'),
            description: 'Softly smooths fine lines and uneven texture by triggering deep collagen renewal. Perfect for visible skin quality improvement without peeling or heavy downtime.',
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 18.png`,
            header: t('neck'),
            description: 'Re-energises thinner tissue of the neck by improving firmness and surface clarity. A targeted solution for early signs of laxity and sun-related texture change.',
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
        {
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/Mask Group 23.png`,
            header: t('delicate_areas'),
            description: 'Targeted collagen renewal for thin, sensitive skin, eyes, lips, neck, chest. Softens fine lines and improves tone without surface damage.',
            // buttonText: 'LEARN MORE',
            // buttonUrl: '/'
        },
    ];

    const accodirons = [
        {
            title: t('what'),
            content: t('erbium_glass_softlift.what'),
        },
        {
            title: t('how'),
            content: t('erbium_glass_softlift.how'),
        },
        {
            title: t('benefits'),
            content: t('erbium_glass_softlift.benefits'),
        },
        {
            title: t('zone'),
            content: t('erbium_glass_softlift.zone'),
        },
        {
            title: t('pairs'),
            content: t('erbium_glass_softlift.pairs'),
        },
        {
            title: t('downtime'),
            content: t('erbium_glass_softlift.downtime'),
        },
        {
            title: t('when_expected_results'),
            content: t('erbium_glass_softlift.expected_results'),
        },
        // {
        //     title: t('pairing'),
        //     content: t('erbium_glass_softlift.pairing'),
        // },
    ];

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('erbium_glass_softlift.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('erbium_glass_softlift.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('erbium_glass_softlift.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('erbium_glass_softlift.sessions'),
        }
    ];

    const imageSet = { before: '/images/mask_1.png', after: '/images/fractional/Mask Group 18.png' }

    return (
        <Box>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} >
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/12/alma-1.png`} width={1} height={1} sx={{ objectFit: 'cover' }} />
                    </Box>
                </HalfSizeBanner>
            </Box>

            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection 
                titleSize={{ md: 7, xs: 12 }}
                data={{
                    type: t('skinTherapies'),
                    title: t('erbium_glass_softlift.mainTitle'),
                    description: t('erbium_glass_softlift.mainDesc'),
                    bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e ERBIUM GLASS SOFTLIFT")}`,
                    price: `Erbium Glass Softlift: 150€\n`,
                    doctorIncluded: true
                }} />
            </Box>

            <Box marginTop={{ md: '108px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>

            <Box sx={{ width: { xl: '1340px', xs: '90%' }, marginX: 'auto' }} marginTop={{ md: '90px', xs: '50px' }}>
                <Box sx={{ height: {md: 440, xs: 'auto'} }}>
                    <BigCard
                        data={{
                            height: {md: 460, xs: 1},
                            // book: '/',
                            type: t('erbium_glass_softlift.tech'),
                            // learn: '/',
                            title: 'ALMA Laser Technology',
                            descriptionSize: 12,
                            size: { md: 6, xs: 12 },
                            btnContainer: { md: 12, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/27/Mask Group 8.png`,
                            flexDirection: {md: 'row-reverse', xs: 'column-reverse'},
                            description: t('erbium_glass_softlift.techDesc'),
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e ERBIUM GLASS SOFTLIFT")}`
                        }}
                    />
                </Box>
            </Box>

            {/* <Grid container gap={'40px'} className="generalContainer" sx={{ marginX: 'auto', }} marginTop={{md: '80px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>Treatment Areas</Typography>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1rem'} marginTop={'22px'} fontWeight={'bold'}>Ideal for the face, neck, and even delicate areas (it’s safe for most skin types), as well as localized scars on the body.</Typography>
                </Grid>
                <Grid size={12}>
                    <Cards data={data} headerAlign={'center'} descriptionAlign={'center'} buttonAlign={'auto'} />
                </Grid>
            </Grid> */}

            <Grid container gap={{md: '80px', xs: '50px'}} className="generalContainer" sx={{ marginX: 'auto',  }} marginTop={{md: '90px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>


            {/* <Box bgcolor={'#E9DFD5'} marginTop={{md: '138px', xs: '50px'}}>
                <Grid container gap={'29px'} className="generalContainer" sx={{ marginX: 'auto', paddingTop: {md: '80px', xs: '50px'}, paddingBottom: {md: '204px', xs: '50px'} }} justifyContent={'center'}>
                    <Grid size={12}>
                        <Grid container gap={'14px'} justifyContent={'center'}>
                            <Grid size={12}>
                                <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '2.875rem', xs: '1.875rem' }} fontWeight={'bold'}>Subtle precision for the most delicate skin.</Typography>
                            </Grid>
                            <Grid size={{ md: 8, xs: 12 }}>
                                <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={{ md: '1.5rem', xs: '1rem' }}>See how fragile areas regain smoothness, firmness, and clarity. Fine lines soften, texture refines, and tone evens all with gentle, non-ablative renewal that preserves the skin’s natural integrity.</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ md: 8, xs: 12 }}>
                        <CompareSlider imageSet={imageSet} height={{ md: '480px', xs: '300px' }} />
                    </Grid>
                </Grid>
            </Box> */}

             <Box className="generalContainer" marginX={'auto'} paddingTop={{md: '80px', xs: '50px'}} >
                
            </Box>

            {/* <Box className="generalContainer" marginX={'auto'} paddingTop={{md: '80px', xs: '50px'}} paddingBottom={{md: '206px', xs: '50px'}}>
                <ContentCard
                    data={{
                        book: '/',
                        // learn: '/skin/emfusion-trans-dermal-infusion-facial',
                        imageUrl: "${process.env.REACT_APP_SITE_URL}/images/2025/12/Mask Group 25.png",
                        type: "Pairing",
                        title: "Trans-Epidermal Delivery",
                        description: "Trans-Epidermal Delivery technology to push a customized cocktail of serums (rich in peptides, vitamins, and hyaluronic acid) through those micro-channels . This deeply nourishes the fresh laser-treated skin, amplifying hydration and collagen benefits beyond what laser alone can do.",
                        direction: "row-reverse"
                    }}
                    heigth={{ md: '440px', xs: 'auto' }}
                />
            </Box> */}
        </Box>
    )
}